import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Space,
  Button,
  Modal,
  Input,
  message,
  Spin,
  InputNumber,
  Checkbox,
} from "antd";
import { isLogged, getAuthToken } from "../../../helpers/account";
import { api } from "../../../config/api";
import { useDispatch } from "react-redux";

const { TextArea } = Input;

const NewInquiryResponseForm = ({ inquiryUuid, onResponseCreated }) => {
  const { t } = useTranslation();
  const [newResponseModalOpen, setNewResponseModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    price: "",
    message: "",
    delivery_days: "",
    is_anonymous: false, // Added for anonymous responses
  });
  const dispatch = useDispatch();

  const handleCreateNewResponse = () => {
    if (validateFormData()) {
      setLoading(true);

      const apiData = {
        price: formData.price,
        message: formData.message,
        delivery_days: formData.delivery_days,
        is_anonymous: formData.is_anonymous, // Include is_anonymous in API data
      };

      const apiUrl = `${api.host}/inquiries/${inquiryUuid}/responses`;

      if (isLogged()) {
        fetch(apiUrl, {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/json",
            Authorization: `${getAuthToken()}`,
          }),
          body: JSON.stringify(apiData),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to create inquiry response");
            }
            return response.json();
          })
          .then(() => {
            setLoading(false);
            dispatch({
              type: "inquiryResponseCreated",
              payload: {
                inquiryResponseCreated: new Date().getSeconds(),
              },
            });
            message.success(t('inquiry.form.responseCreated'));
            setNewResponseModalOpen(false);
            setFormData({
              price: "",
              message: "",
              delivery_days: "",
              is_anonymous: false, // Reset is_anonymous
            });
            if (onResponseCreated) {
              onResponseCreated();
            }
          })
          .catch((error) => {
            setLoading(false);
            console.error("Error while creating inquiry response:", error);
            message.error(t('inquiry.form.responseCreateError'));
          });
      }
    }
  };

  const validateFormData = () => {
    if (!formData.price || !formData.message || !formData.delivery_days) {
      message.error(t('common.allFieldsRequired'));
      return false;
    }
    if (isNaN(parseFloat(formData.price))) {
      message.error(t('inquiry.form.priceMustBeNumber'));
      return false;
    }
    if (isNaN(parseInt(formData.delivery_days))) {
      message.error(t('inquiry.form.deliveryDaysMustBeNumber'));
      return false;
    }
    return true;
  };

  const handleNewResponse = () => {
    setNewResponseModalOpen(true);
  };

  const handleCancelNewResponse = () => {
    setNewResponseModalOpen(false);
  };

  return (
    <>
      <Spin spinning={loading}>
        <Button 
          onClick={handleNewResponse} 
          type="primary"
          size="large"
          style={{
            height: "56px",
            fontSize: "18px",
            width:"100%",
            fontWeight: "600"
          }}
        >
          ✨ {t('inquiry.form.submitOffer')}
        </Button>

        <Modal
          title={t('inquiry.form.newResponse')}
          open={newResponseModalOpen}
          onOk={handleCreateNewResponse}
          onCancel={handleCancelNewResponse}
          okText={t('common.add')}
          cancelText={t('common.cancel')}
          styles={{
            body: { padding: "32px" },
            header: { borderBottom: "1px solid #f0f0f0", paddingBottom: "16px" }
          }}
        >
          <Space size={15} direction="vertical" style={{ width: "100%" }}>
            <InputNumber
              placeholder={t('inquiry.form.price')}
              min={1}
              onChange={(value) => setFormData({ ...formData, price: value })}
              value={formData.price}
              size="large"
              style={{ width: "100%" }}
            />
            <TextArea
              placeholder={t('inquiry.form.responseContent')}
              rows={4}
              onChange={(e) =>
                setFormData({ ...formData, message: e.target.value })
              }
              value={formData.message}
              size="large"
            />
            <InputNumber
              placeholder={t('inquiry.form.deliveryDays')}
              min={1}
              onChange={(value) =>
                setFormData({ ...formData, delivery_days: value })
              }
              value={formData.delivery_days}
              size="large"
              style={{ width: "100%" }}
            />
         
          </Space>
        </Modal>
      </Spin>
    </>
  );
};

export default NewInquiryResponseForm;